/* Searches filter values only; never submits a product query or drops a selection. */
if (!customElements.get('bw-filter-search')) {
  customElements.define('bw-filter-search', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.input = this.querySelector('input');
      this.clear = this.querySelector('button');
      this.status = this.querySelector('[role="status"]');
      this.input.addEventListener('input', event => {
        event.stopPropagation();
        this.filter();
      });
      this.input.addEventListener('keydown', event => {
        if (event.key === 'Enter') event.preventDefault();
        if (event.key === 'Escape') this.escapeClearedSearch = false;
        if (event.key === 'Escape' && this.input.value) {
          this.escapeClearedSearch = true;
          event.preventDefault();
          event.stopPropagation();
          this.input.value = '';
          this.filter();
        }
      });
      // Dawn also closes disclosure groups on keyup; clearing a search must stay open.
      this.input.addEventListener('keyup', event => {
        if (event.key === 'Escape' && this.escapeClearedSearch) {
          event.stopPropagation();
          this.escapeClearedSearch = false;
        }
      });
      this.clear.addEventListener('click', () => {
        this.input.value = '';
        this.filter();
        this.input.focus();
      });
    }
    filter() {
      const normalize = value => value.toLocaleLowerCase('de').normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(/ß/g, 'ss').trim();
      const term = normalize(this.input.value);
      const group = this.closest('.js-filter');
      const items = group.querySelectorAll('.facets__item, .mobile-facets__item');
      let matches = 0;
      items.forEach(item => {
        const label = item.querySelector('.facet-checkbox__text-label');
        const match = !term || normalize(label?.textContent || '').includes(term);
        const checked = !!item.querySelector('input:checked');
        if (match) matches++;
        item.classList.toggle('bw-filter-match', !!term && (match || checked));
        item.classList.toggle('bw-filter-hidden', !!term && !match && !checked);
      });
      group.classList.toggle('bw-filter-searching', !!term);
      this.clear.hidden = !term;
      this.status.textContent = !term ? '' : matches === 0
        ? 'Keine passenden Werte. Aktive Auswahlen bleiben sichtbar.'
        : `${matches} passende Werte. Aktive Auswahlen bleiben sichtbar.`;
    }
  });
}
